export const erpIdsEnum = {
    1: 'wapro-mag',
};